import { useState } from "react";
import { signIn } from "next-auth/react";
import PropTypes from "prop-types";
import { Modal } from "@components/ModalV2";
import { Button } from "@components/Button";
import { SvgIcon } from "@components/Icon";
import { trackEvent } from "@lib/track-event";
import { LogoGoogle, LogoApple } from "@icons/index";
import styles from "./login.module.css";

export function Login({ isShown, toggle }) {
  const [showLoader, setShowLoader] = useState(null);
  const logIn = (event) => {
    setShowLoader(event.target.value);
    trackEvent("login", { method: event.target.value });
    signIn(event.target.value);
  };

  return (
    <Modal isShown={isShown} hide={toggle} ariaLabel="loginModalId">
      <section className={styles.main}>
        <h1 id="loginModalId" className={styles.header}>
          Welcome to Kotn
        </h1>
        <article className={styles.description}>
          <p>
            An elevated and ethically-driven product label dedicated to lasting ways of life.
            Apparel, home goods, and accessories rooted in the principles of timeless design and
            sustainable production.
          </p>
        </article>

        <div className={styles.buttonGroup}>
          <Button
            description="google"
            descriptionText="login to your kotn account with Google"
            handleClick={logIn}
            value="google"
            variant="secondary"
            full
            isLoading={showLoader === "google"}
            isDisabled={showLoader !== null}
          >
            <SvgIcon Icon={LogoGoogle} />
            Continue with Google
          </Button>
          <Button
            description="apple"
            descriptionText="login to your kotn account with Apple"
            handleClick={logIn}
            value="apple"
            variant="secondary"
            full
            isLoading={showLoader === "apple"}
            isDisabled={showLoader !== null}
          >
            <SvgIcon Icon={LogoApple} />
            Continue with Apple
          </Button>
        </div>
      </section>
    </Modal>
  );
}

Login.propTypes = {
  isShown: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
